import type ChartAction from './ChartAction';

/**
 * Вертикальный отрезок на дату: от start к end («было → стало»).
 * На start — засечка, на end — точка. end === null — только засечка (результата нет).
 * isMuted — блеклая отрисовка; что считать неудачей, решает потребитель.
 */
class ChartRange {
  readonly date: Date;

  readonly start: number;

  readonly end: number | null;

  readonly isMuted: boolean;

  readonly title: string;

  /** Ссылка на фрагменте первой строки тултипа (номер документа); null — без ссылки */
  readonly action: ChartAction | null;

  constructor(date: Date, start: number, end: number | null, isMuted: boolean, title: string, action: ChartAction | null = null) {
    this.date = date;
    this.start = start;
    this.end = end;
    this.isMuted = isMuted;
    this.title = title;
    this.action = action;
  }
}

export default ChartRange;
